import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CommunicationService {
  openChat = new EventEmitter<any>();
  readonly openChat$ = this.openChat.asObservable();

  constructor() {}
}
